<template>
  <el-form class="tw-flex tw-flex-col tw-items-start tw-gap-4 tw-justify-between tw-w-full md:tw-flex-row md:tw-items-center">
    <i-form-item
      :label="$t('common.filters.status')"
      class="tw-w-full md:tw-w-1/3"
    >
      <el-select
        :model-value="filters.is_active"
        placeholder=""
        filterable
        clearable
        @change="(payload) => updateFilter('is_active', payload)"
      >
        <el-option
          :label="$t('common.fields.active')"
          :value="10"
        />
        <el-option
          :label="$t('common.fields.not_active')"
          :value="20"
        />
      </el-select>
    </i-form-item>
    <DebouncedSearch
      :query="searchQuery"
      :search="search"
      :placeholder="$t('common.actions.search')"
      is-full-width
      class="tw-w-full md:tw-w-1/3"
    />
  </el-form>
</template>

<script>
import DebouncedSearch from '@/components/shared/DebouncedSearch.vue';

export default {
  name: 'AdministrationCompaniesFilters',
  components: { DebouncedSearch },
  props: {
    storePath: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      searchQuery: '',
    };
  },
  computed: {
    filters() {
      return this.getStateFragment().filters;
    },
  },
  mounted() {
    this.searchQuery = this.filters.search;
  },
  methods: {
    getStateFragment() {
      let statePath = this.$store.state;
      const storePathArray = this.storePath.split('/');

      storePathArray.forEach((path) => {
        statePath = statePath[path];
      });

      return statePath;
    },
    updateFilter(field, payload) {
      this.$store.commit(`${this.storePath}/updateFilter`, { field, payload });
    },
    search(query) {
      this.$store.commit(`${this.storePath}/updateFilter`, { field: 'search', payload: query });
    },
  },
};
</script>
